<template>
  <div class="field-input-phone form-group">
    <label
      v-html="fieldData.label"
      :for="fieldData.field_name"
      :class="(isRequired ? 'field-required' : '')">
    </label>

    <div class="input-group" :style="fieldStyles()">
      <field-icon :fieldData="fieldData"></field-icon>

      <the-mask
        :ref="fieldData.field_name"
        :disabled="(!!showDisabled())"
        :aria-describedby="`${fieldData.field_name}_describedby`"
        name="phone_masked"
        type="tel"
        :id="fieldData.field_name"
        v-model="phone_masked_input_value"
        :mask="input_mask"
        :placeholder="fieldData.placeholder"
        v-bind:class="{'form-control': true, 'error': errors.has(fieldData.field_name) }">
      </the-mask>

      <input
      :disabled="(!!showDisabled())"
      v-show="false"
      :name="fieldData.field_name"
      type="text"
      class="form-control"
      v-model="phone_masked_input_value"
      v-validate="fieldData.rules">

      <span v-bind:class="{'warning fas fa-exclamation-triangle': errors.has(fieldData.field_name) }"></span>
    </div>

    <div class="invalid-feedback d-block">{{ errors.first(fieldData.field_name) }}</div>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';
import FieldIcon from '../../presentational/FieldIcon';

export default {
  directives: { mask },
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData'],
  data() {
    return {
      field_rules: { required: false }, // Default rule for input validation
      phone_masked_input: '', // Holds the phone masked input value outside of the computed property to avoid an infinite loop
      input_mask: '###-###-####', // TODO: Use config value
    };
  },
  components: { FieldIcon },
  computed: {
    isRequired() {
      return this.fieldData.rules && this.fieldData.rules.required === true;
    },
    /**
     * Uses data property `masked_input` to store the input field's value without masked characters
     * added. A separate property needs to be used otherwise the computed property would keep updating
     * itself and end up in an infinite loop!
     */
    phone_masked_input_value: {
      get() {
        return this.fieldData.field_value;
      },
      set(newValue) {
        this.fieldData.field_value = newValue;
      },
    },
  },
  methods: {
    /**
     * Calculates the width of this component based on the data.
     * TODO: Refactor to be more universal rather than only for width.
     */
    fieldStyles() {
      const defaultFieldWidth = '50%';
      const rules = this.fieldData.rules || {};
      const fieldWidth = rules.max || rules.digits || null;
      const finalFieldWidth = fieldWidth ? `${fieldWidth + 4}em` : defaultFieldWidth;

      return `width: ${finalFieldWidth}; max-width: 100%;`;
    },
    showDisabled() {
      return !this.fieldData.is_enabled;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/admin/interactive/InputPhone.vue?8c4c1ba6